





































import { Vue, Component, Watch } from 'vue-property-decorator'
import { State, Mutation, Action, Getter } from 'vuex-class'
import { RootState } from '@/store/types'
import { UI_SET_SEARCH_TERM } from '@/store/ui/constants'
import { keybindToSymbols, isElectron } from '@/util/Helpers'
import PStorage, { KEYBIND_GLOBAL_SEARCH } from '@/util/PStorage'
import { Maybe } from '@/types/general'
import Entry from '@/data/entry-model'

@Component({ name: 'search-box' })
export default class SearchBox extends Vue {
    @State((state: RootState) => state.ui.searchTerm)
    term!: string

    @Mutation(UI_SET_SEARCH_TERM)
    setSearchTerm!: (term: string) => void

    @State((state: RootState) => state.ui.searchFocused)
    searchFocused!: boolean

    @Getter
    deepestVault!: Maybe<Entry>

    @Watch('searchFocused')
    onSearchFocus(focus: boolean): void {
        if (focus) {
            (this.$refs.search as HTMLElement).focus()
        } else {
            (this.$refs.search as HTMLElement).blur()
        }
    }

    get placeholder(): string {
        const search = this.deepestVault
            ? `Search in ${this.deepestVault.title}`
            : 'Search everything'
        if (isElectron()) {
            const keybind = keybindToSymbols(
                PStorage.getOrDefault(KEYBIND_GLOBAL_SEARCH, 'CmdOrCtrl+\\')
            )
            return `${search} [ ${keybind} ]`
        }
        return search
    }
}
